<script>
import AdminLayout from '@layouts/admin-main'
import DepositList from '@components/admin/deposit-list'

export default {
  page: {
    title: 'Admin::DepositList',
    meta: [{ name: 'description', content: 'Admin::DepositList' }],
  },
  components: { AdminLayout, DepositList },
}
</script>

<template>
  <AdminLayout>
    <DepositList></DepositList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
